import StatsChatAssistant from '@aytm/lib/skipper/assistants/stats/StatsChatAssistant'
import SupportChatAssistant from '@aytm/lib/skipper/assistants/support/SupportChatAssistant'

import { StatsChatAssistant as TStatsChatAssistant } from '@aytm/lib/skipper/assistants/stats/types'
import { SupportChatAssistant as TSupportChatAssistant } from '@aytm/lib/skipper/assistants/support/types'

import {
  GUIDED_REPORT_PILL_LABEL,
  SKIPPER_REPORT_FEATURE,
  SURVEY_IN_FIELD_TOOLTIP
} from '@aytm/app/stats/page/sidebar/reports/lib/skipperGuidedReportsConst'

type SkipperReportPage = {
  features?: { [token: string]: { status?: string } }
  survey_finished_at?: string | null
  surveyId?: number | string
}

let skipperChatStatsAssistant: TStatsChatAssistant | undefined
let skipperChatSupportAssistant: TSupportChatAssistant | undefined

const skipperChatAssistants = {
  get assistants() {
    if (!skipperChatStatsAssistant) {
      skipperChatStatsAssistant = StatsChatAssistant()
      // The Guided Reports pill takes the two gates the sidebar's Create button reads: the
      // survey-level Skipper Reports flag decides whether it is offered at all, and a survey still
      // in field leaves it inert with the reason on hover.
      skipperChatStatsAssistant.guidedReportsPillGetter = () => {
        const page = window as unknown as SkipperReportPage
        if ('on' !== page.features?.[SKIPPER_REPORT_FEATURE]?.status) return null

        const inField = !page.survey_finished_at
        return {
          label: GUIDED_REPORT_PILL_LABEL,
          disabled: inField,
          hint: inField ? SURVEY_IN_FIELD_TOOLTIP : undefined
        }
      }
      skipperChatStatsAssistant.contextGetter = () => {
        if (window.StatPage?.model?.getApiKey && !window.StatPage.model.isApiKeyInvalid()) {
          const apiKeyData = window.StatPage.model.getApiKey()
          const surveyId = Number((window as unknown as SkipperReportPage).surveyId)
          return apiKeyData
            ? {
                token: apiKeyData.code,
                expire: apiKeyData.expire,
                survey_id: Number.isFinite(surveyId) ? surveyId : null
              }
            : null
        }
        return null
      }
    }
    if (!skipperChatSupportAssistant) {
      skipperChatSupportAssistant = SupportChatAssistant()
    }
    return [skipperChatStatsAssistant, skipperChatSupportAssistant]
  },

  initialize() {
    if (window.$Skipper?.ChatButton) {
      window.$Skipper.ChatButton.render({
        assistants: this.assistants
      })
      return true
    }
    return false
  }
}

export default skipperChatAssistants

if (typeof window !== 'undefined') {
  window.$STATS = window.$STATS || {}
  window.$STATS.skipperChatAssistants = skipperChatAssistants
}
